import { Component, OnInit, Input, ChangeDetectorRef, ViewChild, ElementRef } from '@angular/core';
import { NgbActiveModal } from '@otas/modal/modal-ref';
import { DateService } from '../../services/date.service';
import { PaginationService } from '@otas/shared/pagination/pagination.service';
import { BookedPoojaInvoiceJson, PoojaBookedJson } from '@otas/model/pooja/pooj-booking-response';
import { GlobalUtilService } from '@otas/core/services/global-util.service';

@Component({
  selector: 'app-invoice-modal',
  templateUrl: './invoice-modal.component.html',
  styleUrls: ['./invoice-modal.component.css'],
  standalone: false
})
export class InvoiceModalComponent implements OnInit {
  invoiceList: BookedPoojaInvoiceJson;
  @Input() doc: any;
  public pager: any = {};
  public pagedItems: PoojaBookedJson[] = [];
  public page = 1;
  loading = false;
  total: number;
  printers: any[] = [];
  selectedPrinter = '';
  @ViewChild('invoiceTemplate', { static: false }) invoiceTemplate: ElementRef;

  constructor(public activeModal: NgbActiveModal, private pagerService: PaginationService, private globalUtilService: GlobalUtilService) { }
  ngOnInit() {
    this.setPage(this.page);
    this.listPrinters();
  }
  printSingleInvoice(invoice) {
    this.globalUtilService.IPCRendererSend('handlePrintRequest', invoice, false);
  }
  print() {
    // window.scroll(0, 0);
    // window.print();
    this.activeModal.close(true);
  }
  public setPage(page: number) {
    this.page = page;
    if (page < 1) {
      this.pagedItems = [];
      return;
    }
    this.pager = this.pagerService.getPager(this.invoiceList.list.length, page, 1);
    this.pagedItems = this.invoiceList.list.slice(this.pager.startIndex, this.pager.endIndex + 1);
  }
  getDateFormatted(date) {
    const formattedDate = DateService.dateToFormattedString(date);
    return formattedDate;
  }
  dismiss() {
    this.activeModal.dismiss();
  }

  listPrinters() {
    if (this.globalUtilService.isTauriApp) {
      try {
        window.electronAPI.getPrinters().then((printers) => {
          this.printers = printers || [];
          if (this.printers.length > 0) {
            this.selectedPrinter = this.printers[0].name; // default selection
          }
        })
      } catch (err) {
        console.error('Failed to load printers:', err);
      }
    }
  }

  async printSelectedInvoice(invoices: any[]) {
    if (!invoices || invoices.length === 0) {
      alert('No invoice data available.');
      return;
    }

    // Get the rendered HTML from the template
    const htmlContent = this.invoiceTemplate.nativeElement.innerHTML;

    // Wrap it with necessary styles for printing (including Malayalam font support)
    const fullHtml = `
      <html>
        <head>
          <meta charset="UTF-8">
          <link href="https://fonts.googleapis.com/css2?family=Noto+Sans+Malayalam&display=swap" rel="stylesheet">
          <style>
            body {
              font-family: 'Noto Sans Malayalam', 'Segoe UI', sans-serif;
              margin: 30px;
              font-size: 14px;
            }
            table {
              border:none;
            }
            th, td {
              padding: 8px;
              text-align: left;
            }
            .d-print-none {
              display: none !important;
            }
              textarea {
              border: none;
              resize: none;
            }
          </style>
        </head>
        <body>
          ${htmlContent}
        </body>
      </html>`;

    // Send to printer
    if (this.globalUtilService.isTauriApp) {
      try {
        await window.electronAPI.printInvoice(fullHtml, this.selectedPrinter);
      } catch (err) {
        console.error('Error while printing:', err);
      }
    }
  }
}

